import type { AddressFieldsValues } from '@backmarket/http-api/src/api-specs-shipping/address/address-validation.types'
import type { StripNullish } from '@backmarket/utils/types/StripNullish'

export const FORM_MODAL_NAME = 'add-dsa-contact-form-modal'

export const DSA_FORM_TYPES = {
  ALL_EU: 'ALL_EU',
  SOME_OR_ALL_NON_EU: 'SOME_OR_ALL_NON_EU',
}

export const DSA_FORM_STEPS = {
  PRODUCT_ORIGIN: 'PRODUCT_ORIGIN',
  CONTACT_DETAILS: 'CONTACT_DETAILS',
}

export type DsaFormValues = Required<
  StripNullish<
    Pick<
      AddressFieldsValues,
      | 'city'
      | 'country'
      | 'postalCode'
      | 'stateOrProvince'
      | 'street'
      | 'street2'
    > & {
      businessName: string
      email: string
      phone: string
      website: string
    }
  >
>
